import { VisitNodePassage } from "../../types";
export const leafToPartialVariationVisitor = () => (args) => {
    if (args?.context?.visitNodePassage !== VisitNodePassage.Leaf) {
        return;
    }
    const { visitable: element } = args;
    if (element?.measures) {
        Object.keys(element.measures).forEach((key) => {
            if (element.measures) {
                const amount = element.measures[key];
                if (amount?.amount) {
                    element.measures[key] = { currentValue: amount.amount };
                    element.measures.Currency = amount.currency;
                }
            }
        });
    }
};
